module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "27",
      "height": "27",
      "viewBox": "0 0 27 27",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.4",
      "y": "0.4",
      "width": "26.2",
      "height": "26.2",
      "rx": "13.1",
      "fill": "white",
      "stroke": "#F3103D",
      "stroke-width": "0.8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.8769 8.66359H15.6895V8.26588C15.6895 7.608 15.1543 7.07275 14.4964 7.07275H12.9056C12.2477 7.07275 11.7124 7.608 11.7124 8.26588V8.66359H9.52503C8.97679 8.66359 8.53076 9.10962 8.53076 9.65786V11.0498C8.53076 11.2695 8.70884 11.4475 8.92847 11.4475H9.14582L9.48941 18.6631C9.51976 19.3003 10.0432 19.7994 10.6812 19.7994H16.7208C17.3587 19.7994 17.8822 19.3003 17.9125 18.6631L18.2561 11.4475H18.4735C18.6931 11.4475 18.8712 11.2695 18.8712 11.0498V9.65786C18.8712 9.10962 18.4252 8.66359 17.8769 8.66359ZM12.5078 8.26588C12.5078 8.04659 12.6863 7.86817 12.9056 7.86817H14.4964C14.7157 7.86817 14.8941 8.04659 14.8941 8.26588V8.66359H12.5078V8.26588ZM9.32618 9.65786C9.32618 9.54822 9.41539 9.45901 9.52503 9.45901H17.8769C17.9866 9.45901 18.0758 9.54822 18.0758 9.65786V10.6521C17.9532 10.6521 9.83408 10.6521 9.32618 10.6521V9.65786ZM17.118 18.6252C17.1079 18.8376 16.9334 19.004 16.7208 19.004H10.6812C10.4685 19.004 10.294 18.8376 10.2839 18.6252L9.94213 11.4475H17.4598L17.118 18.6252Z",
      "fill": "#F3103D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.6956 18.2098C13.9152 18.2098 14.0933 18.0317 14.0933 17.8121V12.6418C14.0933 12.4222 13.9152 12.2441 13.6956 12.2441C13.4759 12.2441 13.2979 12.4222 13.2979 12.6418V17.8121C13.2979 18.0317 13.4759 18.2098 13.6956 18.2098Z",
      "fill": "#F3103D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.6873 18.2098C15.9069 18.2098 16.085 18.0317 16.085 17.8121V12.6418C16.085 12.4222 15.9069 12.2441 15.6873 12.2441C15.4676 12.2441 15.2896 12.4222 15.2896 12.6418V17.8121C15.2896 18.0317 15.4676 18.2098 15.6873 18.2098Z",
      "fill": "#F3103D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.7073 18.2098C11.9269 18.2098 12.105 18.0317 12.105 17.8121V12.6418C12.105 12.4222 11.9269 12.2441 11.7073 12.2441C11.4876 12.2441 11.3096 12.4222 11.3096 12.6418V17.8121C11.3096 18.0317 11.4876 18.2098 11.7073 18.2098Z",
      "fill": "#F3103D"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e80adff6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e80adff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/TrashIcon.vue
// module id = 779
// module chunks = 0